export enum POSITION {
    PREV = "prev",
    NEXT = "next",
    CURRENT = "current",
    HIDDEN = "hidden",
}
